import firebase from "firebase/app";

import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";

import { db } from "astrid-firebase";
import getDistributionChannelsQuery from "astrid-firestore/src/api/distribution/getDistributionChannelsQuery";
import { useDocumentData, useLoadingValues } from "astrid-firestore/src/hooks";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import LoadingContext from "../../ui/components/LoadingContext/LoadingContext";

import useArticles from "../../articles/hooks/useArticles";
import useArtifacts from "../../artifacts/hooks/useArtifacts";
import featureFlags from "../../authorization/constants/featureFlags";

import WorkView from "../views/WorkView/WorkView";

export default function Work() {
	const { organization, work } = useOutletContext();

	const [[publisher, articles, artifacts, channels, productions], loading, error] = useLoadingValues(
		useDocumentData(work.publisher.ref),
		useArticles({ work }),
		useArtifacts({ work }),
		useCollectionData(getDistributionChannelsQuery(firebase)),
		useCollectionData(db.collection("productions").where("work.id", "==", work.id).where("deleted", "==", false)),
	);

	const context = {
		articles,
		artifacts,
		channels,
		organization,
		productions,
		publisher,
		work,
	};

	return (
		<LoadingContext data={publisher} loading={loading} error={error} featureFlag={featureFlags.FLATTENING}>
			<WorkView work={work}>
				<Outlet context={context} />
			</WorkView>
		</LoadingContext>
	);
}
